import { FunctionComponent } from 'react';
import { FormControlLabel } from '../../../tailwindcomponents';
import { DatePicker } from '../../../MaterialUiComponents';
import { Autocomplete, TextField, Button, Checkbox, Tooltip, SelectMultiple } from '../../../tailwindcomponents';
import { LinePlannerFilters } from '../../../types/linePlanner';
import { hangarLineOptions, statusOptions, workTypeOptions, aircraftTypeOptions } from '../../../properties/lineProperties';
import { DateTime } from 'luxon';

type WorkPackageFiltersProps = {
  allTails: Array<string>;
  filters: LinePlannerFilters;
  onFilterChange: (updates: Partial<LinePlannerFilters>) => void;
  onRefresh: () => void;
};

const WorkPackageFilters: FunctionComponent<WorkPackageFiltersProps> = ({
  allTails,
  filters,
  onFilterChange,
  onRefresh,
}) => {
  return (
    <div className="flex flex-wrap items-end gap-2 mb-3">
      <div className="w-20">
        <DatePicker
          onDateChange={(date: Date) => onFilterChange({ dateFrom: date.toISOString() })}
          type={"Date"}
          label="Created from"
          selected={DateTime.fromISO(filters.dateFrom).toJSDate()}
        />
      </div>

      <div className="w-20">
        <DatePicker
          onDateChange={(date: Date) => onFilterChange({ dateTo: date.toISOString() })}
          type={"Date"}
          label="Created to"
          selected={DateTime.fromISO(filters.dateTo).toJSDate()}
        />
      </div>

      <Autocomplete
        className="w-20"
        noOptionsText="No tails found"
        options={allTails}
        value={filters.tail}
        clearOnEscape
        autoHighlight
        onChange={(e: any, newValue: string | null) => onFilterChange({ tail: (newValue ?? "") as string })}
        renderInput={(params) => (
          <TextField {...params} label="Tails" variant="standard" />
        )}
      />

      <SelectMultiple
        options={Object.values(hangarLineOptions)}
        onSelectedItem={(e: any) => onFilterChange({ filterByHangers: e.target.value })}
        selectedItemsString={filters.filterByHangers}
        width={100}
        filter_by_text={"Hangars"}
      />

      <SelectMultiple
        options={Object.values(statusOptions)}
        onSelectedItem={(e: any) => onFilterChange({ filterByStatus: e.target.value })}
        selectedItemsString={filters.filterByStatus}
        width={120}
        filter_by_text={"Status"}
      />

      <SelectMultiple
        options={Object.values(workTypeOptions)}
        onSelectedItem={(e: any) => onFilterChange({ filterByWorkType: e.target.value })}
        selectedItemsString={filters.filterByWorkType}
        width={100}
        filter_by_text={"Work type"}
      />

      <SelectMultiple
        options={Object.values(aircraftTypeOptions)}
        onSelectedItem={(e: any) => onFilterChange({ filterByAircraftTypes: e.target.value })}
        selectedItemsString={filters.filterByAircraftTypes}
        width={100}
        filter_by_text={"Aircraft type"}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={filters.dueDateHourCycles}
            onChange={() => onFilterChange({ dueDateHourCycles: !filters.dueDateHourCycles })}
            name="checkedA"
          />
        }
        label="Due Date Hour/Cycles"
      />

      {filters.dueDateHourCycles && (
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.dueDateExceedsFifteen}
              onChange={() => onFilterChange({ dueDateExceedsFifteen: !filters.dueDateExceedsFifteen })}
              name="checkedA"
            />
          }
          label="Due Date < 15"
        />
      )}

      <div className="ds-filter-actions">
        <Tooltip title="Press R to refresh filtered data" type="primary" placement="top-start">
          <Button variant="contained" color="primary" size="medium" onClick={onRefresh}>
            Filter
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default WorkPackageFilters;
